module.exports = __webpack_public_path__ + "static/media/Alm_Psykiatri_uses_Curoflow_telemedicine_platform.06c47118.webp";